<template>
  <div class="modal fade delete-confirm-modal" tabindex="-1" role="dialog" aria-hidden="true" @click.self="$emit('close')">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title" id="myModalLabel2">Delete</h4>
        </div>
        <div class="modal-body">
          <h4></h4>
          <p>Are you sure you want to delete this?</p>
          <p v-if="deleteTarget!=null">{{deleteTarget.name}}</p>
          <p class="red"><i class="fa fa-exclamation-triangle"></i> This operation cannot be undone.</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal" @click="$emit('close')">Close</button>
          <button type="button" class="btn btn-danger" data-dismiss="modal" @click.once="unregist">Delete</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeleteConfirmModal',
  props: ['deleteTarget'],
  methods: {
    unregist () {
      this.$emit('runDelete')
    }
  }
}
</script>



// WEBPACK FOOTER //
// DeleteConfirmModal.vue?4ff9b680